export const ID_REQUIRED_ERR = ' is Required.';
export const QUARTER_REQUIRED = 'As Of Quarter is required.';
export const START_QTR_REQUIRED_ERR = 'Start Quarter is Required.';
export const GROUP_NUM_REQUIRED_ERR = 'Group Number is Required.';
export const GROUP_NUM_RANGE_ERR = 'Group Number should be 1 ~ 10.';
export const END_QTR_REQUIRED_ERR = 'End Quarter is Required.';
export const END_QTR_ERR = 'End Quarter cannot be prior to Start Quarter.';
export const QUARTER_FORMAT_ERROR =
  "Please enter a valid quarter and year in '#Q##' or '#Q####' format. Example: '1Q98' or '1Q1998'.";
export const DUPLICATE_ALL =
  'There cannot be two rows with the same value for the grouping column and the same start quarter. Please correct and try again. No data has been saved.';
export const OVERAP_DATE =
  'Two rows for the same value of grouping column cannot have overlapping date ranges. Please correct and try again. No data has been saved.';
export const SINGLE_GROUP_HEADER =
  'Only one Reporting Header is allowed for a single Group Number during a given time period. Please correct and try again. No data has been saved.';

export const ALL_REMAINING_VALUE = 'All remaining values';

export const SUCCESS_SAVE_MSG = 'System successfully Saved the information.';
export const GROUPING_COLUMN_REQUIRED = 'Grouping column is Required.';
